'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-left: 8px;\n\n  > div {\n    margin-right: 6px;\n  }\n'], ['\n  margin-left: 8px;\n\n  > div {\n    margin-right: 6px;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _slideSwitcher = require('./slide-switcher');

var _slideSwitcher2 = _interopRequireDefault(_slideSwitcher);

var _fullscreenToggle = require('./fullscreen-toggle');

var _fullscreenToggle2 = _interopRequireDefault(_fullscreenToggle);

var _tocToggle = require('./toc-toggle');

var _tocToggle2 = _interopRequireDefault(_tocToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ControlsRoot = function ControlsRoot(props) {
  return _react2.default.createElement(
    Controls,
    null,
    _react2.default.createElement(_slideSwitcher2.default, props),
    _react2.default.createElement(
      AdditionalControls,
      null,
      _react2.default.createElement(_fullscreenToggle2.default, { onClick: props.toggleFullscreen }),
      _react2.default.createElement(_tocToggle2.default, { toggled: props.showToc, onClick: function onClick() {
          return props.toggleToc();
        } })
    )
  );
};

var Controls = _styledComponents2.default.div(_templateObject);

var AdditionalControls = _styledComponents2.default.div(_templateObject2);

exports.default = ControlsRoot;